import { makeAutoObservable } from "mobx";
import { IChat } from "../database/AppDatabase";
import { IMChat } from "../models/api/IMChat";
import { ProgStatus } from "../models/utilTypes";
import ApiService from "../services/ApiService";
import { db } from "../services/DexieDbImpl";
import Logger from "../services/Logger";
import { RootStore } from "./RootStore";

export class IMChatListStore{

    // lastChatMap = new Map<string, IMChat>()
    // chatMap = new Map<string, IMChat[]>()

    chatList: IChat[] = []
    rootStore: RootStore
    loadProg: ProgStatus = 'INIT'
    convMatchProg: ProgStatus = 'INIT'

    constructor(rootStore: RootStore){
        makeAutoObservable(this)
        this.rootStore = rootStore
    }

    loadChats(){
        this.loadProg = 'LOADING'
        db.getAllChats().then(resp=>{
            this.loadProg = 'SUCCESS'
            this.chatList = resp
            this.loadConversedMatches()
        })
    }

    loadConversedMatches(silently = false){

        if (!silently) {
            if (this.convMatchProg == 'SUCCESS')
                return
            this.convMatchProg = 'LOADING'
            this.loadProg = 'LOADING'
        }

        ApiService.getConversedMatches({
            uid: this.rootStore.mainStore.uid!
        }).then(resp =>{

            let chatUids = this.chatList.map(item => item.chatterUid)
            resp.data.users.forEach(item =>{
                if(!chatUids.includes(item.uid))
                 db.createChat({
                     chatterId: item.name,
                     chatterUid: item.uid,
                     convStartTime: item.conv_start_date,
                     lastMsgTime: item.conv_start_date,
                     unread: false
                 })
            })
        }).catch(e => Logger.err(e))
          .finally(()=>{
              this.convMatchProg = 'SUCCESS'
              this.loadProg = 'SUCCESS'
          })
    }

    markChatRead(item: IChat){
        item.unread = false
        db.createChat(item)
    }
}